import i18n from '@opsbase/lib-i18n';
import { Palette } from '@opsbase/lib-palette';
import useOpDefinitionValidityCheck from '@opsbase/react-gql-hooks/opdefinition/useOpDefinitionValidityCheck';
import Card from '@opsbase/web-layout/Card';
import Horizontal from '@opsbase/web-layout/Horizontal';
import Vertical from '@opsbase/web-layout/Vertical/Vertical';
import Dots from '@opsbase/web-ui/Dots';
import Text from '@opsbase/web-ui/Text';
import React from 'react';
export function TimestampsOverviewSection(props) {
    const { opDefinition, className } = props;
    const { loading, data } = useOpDefinitionValidityCheck({
        variables: { id: opDefinition.id },
        skip: !opDefinition,
    });
    const validity = loading ? undefined : data.valid;
    const validityMsg = loading ? undefined : data.message;
    return (React.createElement(Card, { classes: { root: className }, padding: true },
        React.createElement(Vertical, { centered: true },
            React.createElement(Horizontal, { centered: true, gutter: true },
                loading && React.createElement(Dots, { color: Palette.LavendarGrey }),
                loading && React.createElement(Text, { variant: "h1" }, i18n.t('validating')),
                !loading && !!validity && (React.createElement(Text, { variant: "h1", color: Palette.GoodGreen }, i18n.t('valid'))),
                !loading && !validity && (React.createElement(Text, { variant: "h1", color: "error", tip: validityMsg }, i18n.t('problems-found')))))));
}
export default TimestampsOverviewSection;
